// M5.2: точка входа SPA.
// Vue 3 + Pinia + Router + PrimeVue (Aura preset).
//
// PrimeVue даёт готовые DataTable / Dialog / Chart / FormControl,
// чтобы не тратить недели на собственные компоненты — для админки
// 100+ клиентов это критично.

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

import App from '@/App.vue';
import router from '@/router';

import 'primeicons/primeicons.css';
import '@/styles/main.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      // Тёмная тема по умолчанию — админка обычно вечером.
      // Переключение по `.app-dark` классу через теггер в шапке.
      darkModeSelector: '.app-dark',
    },
  },
  ripple: true,
  // RU-локализация дат и плюрализации.
  locale: {
    accept: 'OK',
    reject: 'Отмена',
    choose: 'Выбрать',
    upload: 'Загрузить',
    cancel: 'Отмена',
    completed: 'Готово',
    pending: 'В ожидании',
    fileSizeTypes: ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ', 'ЭБ', 'ЗБ', 'ЙБ'],
    dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    dayNamesShort: ['Вск', 'Пнд', 'Втр', 'Срд', 'Чтв', 'Птн', 'Сбт'],
    dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    monthNames: [
      'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
      'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
    ],
    monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    today: 'Сегодня',
    clear: 'Очистить',
    weekHeader: 'Нед',
    firstDayOfWeek: 1,
    dateFormat: 'dd.mm.yy',
    weak: 'Слабый',
    medium: 'Средний',
    strong: 'Сильный',
    passwordPrompt: 'Введите пароль',
    emptyMessage: 'Нет данных',
    emptyFilterMessage: 'Нет результатов по фильтру',
  },
});
app.use(ToastService);
app.use(ConfirmationService);

app.mount('#app');
